import comp from "./MultiSelectQuestions";
export default comp;
